export const buildNavigationLinks = (location = {}) => {
  const normalize = (value) => {
    if (value === undefined || value === null) {
      return '';
    }
    return String(value).trim();
  };

  const latitude = normalize(location.latitude);
  const longitude = normalize(location.longitude);
  const adresseLigne1 = normalize(location.adresseLigne1);
  const adresseLigne2 = normalize(location.adresseLigne2);
  const codePostal = normalize(location.codePostal);
  const ville = normalize(location.ville);
  const libelleLieu = normalize(location.libelleLieu);

  const addressParts = [libelleLieu, adresseLigne1, adresseLigne2, codePostal, ville].filter(Boolean);
  const addressQuery = addressParts.join(', ');
  const encodedAddress = addressQuery ? encodeURIComponent(addressQuery) : null;
  const hasCoords = latitude && longitude;
  const coords = hasCoords ? `${latitude},${longitude}` : null;

  const links = [];

  if (coords) {
    links.push({
      id: 'google',
      label: 'Google Maps',
      url: `https://maps.google.com/?q=${coords}`,
    });
    links.push({
      id: 'apple',
      label: 'Apple Plans',
      url: `http://maps.apple.com/?ll=${coords}`,
    });
    links.push({
      id: 'waze',
      label: 'Waze',
      url: `https://waze.com/ul?ll=${coords}&navigate=yes`,
    });
  } else if (encodedAddress) {
    links.push({
      id: 'google',
      label: 'Google Maps',
      url: `https://maps.google.com/?q=${encodedAddress}`,
    });
    links.push({
      id: 'apple',
      label: 'Apple Plans',
      url: `http://maps.apple.com/?q=${encodedAddress}`,
    });
  }

  return links;
};






